
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"5.5","y":"6.5","width":"5","height":"1","rx":".5","fill":"#484848","stroke":"#484848"}}),_c('rect',{attrs:{"x":"7.5","y":"11.5","width":"9","height":"1","rx":".5","fill":"#484848","stroke":"#484848"}}),_c('rect',{attrs:{"x":"15.5","y":"15.5","width":"5","height":"1","rx":".5","fill":"#484848","stroke":"#484848"}}),_c('path',{attrs:{"d":"M0 1c0-.8.667-1 1-1 .8 0 1 .667 1 1v20c0 .8.667 1 1 1h20c.333 0 1 .2 1 1s-.667 1-1 1H2c-1.6 0-2-1.333-2-2V1z","fill":"#484848"}})])
          )
        }
      }
    